export const heroSlides = [
  {
    id: 'conversation',
    label: 'Advisory',
    phrase: 'Listening before advising.',
    video: 'https://public.readdy.ai/ai/img_res/sandbox/b18faa9c7b59b1c44099a46a9e2ddb65/055bae28-401f-463d-90a3-c59cb3d54fb6_hero-advisory.mp4',
    title: 'Better people decisions start with better conversations.',
    text: 'Independent talent, leadership and people advisory for ambitious organisations.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/b18faa9c7b59b1c44099a46a9e2ddb65/055bae28-401f-463d-90a3-c59cb3d54fb6_hero-advisory.webp',
    alt: 'An HR advisor and a founder discussing a candidate profile in a calm advisory meeting',
    position: '50% 40%',
  },
  {
    id: 'evaluation',
    label: 'Talent',
    phrase: 'Judgment, not volume.',
    video: 'https://public.readdy.ai/ai/img_res/sandbox/b18faa9c7b59b1c44099a46a9e2ddb65/055bae28-401f-463d-90a3-c59cb3d54fb6_hero-evaluation.mp4',
    title: 'Exceptional talent requires clear judgment.',
    text: 'We help organisations identify people with the capability, character and potential to shape what comes next.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/b18faa9c7b59b1c44099a46a9e2ddb65/055bae28-401f-463d-90a3-c59cb3d54fb6_hero-evaluation.webp',
    alt: 'Two talent advisors reviewing annotated candidate profiles at a table',
    position: '50% 45%',
  },
];